import { render, staticRenderFns } from "./DepositsPopup.component.vue?vue&type=template&id=05385144&scoped=true&"
import script from "./DepositsPopup.component.vue?vue&type=script&lang=js&"
export * from "./DepositsPopup.component.vue?vue&type=script&lang=js&"
import style0 from "./DepositsPopup.component.vue?vue&type=style&index=0&id=05385144&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05385144",
  null
  
)

export default component.exports